import {MenuItem, styled} from "@mui/material";
import {Calendar} from "react-multi-date-picker";

export const BarekamCalendar = styled(Calendar)(({theme}) => ({
    '&.rmdp-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        border: '0px',
        color: theme.barekam.calendar.day.color,

        '& .rmdp-calendar': {
            padding: '0px',
        },
        '& .rmdp-header': {
            '& .rmdp-header-values': {
                // display: 'flex',
                color: '#FFF',
                borderRadius: '0.25rem',
                background: '#2A2E3C',
                padding: '0.125rem 0.5rem',
            },
            '& .rmdp-arrow': {
                borderColor: theme.barekam.calendar.day.color,
            },
            '& .rmdp-arrow-container:hover': {
                color: theme.barekam.calendar.day.color,
                backgroundColor: 'unset !important',
                boxShadow: '0px',
            }
        },
        '& .rmdp-week': {
            '& .rmdp-day': {
                margin: '0.2rem',
                color: theme.barekam.calendar.day.color,

                borderRadius: '0.25rem',
            },
            '& .rmdp-week-day': {
                color: theme.barekam.calendar.day.color,
            },
            '& .rmdp-week-day:nth-child(7)': {
                color: `${theme.barekam.calendar.day.selectedColor} !important`,
            },
            '& .rmdp-week-day:nth-child(8)': {
                color: `${theme.barekam.calendar.day.selectedColor} !important`,
            },
            '& .rmdp-day:nth-child(7)': {
                color: `${theme.barekam.calendar.day.selectedColor} !important`,

                '& .rmdp-range': {
                    backgroundColor: `${theme.barekam.calendar.day.selectedColor} !important`,
                    color: '#FFF'
                }
            },
            '& .rmdp-day:nth-child(8)': {
                color: `${theme.barekam.calendar.day.selectedColor} !important`,
            },
            '& .rmdp-range:nth-child(8)': {
                backgroundColor: `${theme.barekam.calendar.day.selectedColor} !important`,
                color: '#FFF !important'
            },
            '& .rmdp-day:first': {
                color: theme.barekam.calendar.day.selectedColor,
            },
            '& .rmdp-disabled': {
                background: '#454D66'
            }
        },
        '& .rmdp-range': {
            borderRadius: '0.25rem',
            border: '0px',
            boxShadow: 'unset',
            background: theme.barekam.calendar.day.selectedBackground,
            color: theme.barekam.calendar.day.color,
        },
        '& .rmdp-today': {
            '& span': {
                fontWeight: '700',
                backgroundColor: `unset !important`,
                color: theme.barekam.calendar.day.color,
            }
        }
    },
}));

export const CalendarFilterButtons = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-around',
    paddingRight: '0.6rem',
    paddingLeft: '0.6rem',

    '& .MuiButton-root:nth-child(2)': {
        marginRight: '0.58rem',
        marginLeft: '0.58rem',
    }
}));

export const HiddenFilterMenuItem = styled(MenuItem)(() => ({
    display: 'none'
}));